/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EloshieldClassicStationaryModuleUpdate
 */
export interface EloshieldClassicStationaryModuleUpdate {
    /**
     * 
     * @type {string}
     * @memberof EloshieldClassicStationaryModuleUpdate
     */
    label?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EloshieldClassicStationaryModuleUpdate
     */
    antennaACount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof EloshieldClassicStationaryModuleUpdate
     */
    antennaBCount?: number | null;
}

/**
 * Check if a given object implements the EloshieldClassicStationaryModuleUpdate interface.
 */
export function instanceOfEloshieldClassicStationaryModuleUpdate(value: object): value is EloshieldClassicStationaryModuleUpdate {
    return true;
}

export function EloshieldClassicStationaryModuleUpdateFromJSON(json: any): EloshieldClassicStationaryModuleUpdate {
    return EloshieldClassicStationaryModuleUpdateFromJSONTyped(json, false);
}

export function EloshieldClassicStationaryModuleUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): EloshieldClassicStationaryModuleUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'] == null ? undefined : json['label'],
        'antennaACount': json['antennaACount'] == null ? undefined : json['antennaACount'],
        'antennaBCount': json['antennaBCount'] == null ? undefined : json['antennaBCount'],
    };
}

export function EloshieldClassicStationaryModuleUpdateToJSON(json: any): EloshieldClassicStationaryModuleUpdate {
    return EloshieldClassicStationaryModuleUpdateToJSONTyped(json, false);
}

export function EloshieldClassicStationaryModuleUpdateToJSONTyped(value?: EloshieldClassicStationaryModuleUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'label': value['label'],
        'antennaACount': value['antennaACount'],
        'antennaBCount': value['antennaBCount'],
    };
}

